<template>
  <div :class="{ field: true, dark: isDark }">
    <h1 v-if="large" class="stat">{{ stat }}</h1>
    <h3 v-else class="stat">{{ stat }}</h3>
    <span class="field-sub">{{ sub }}</span>
    <div class="field-bracket"></div>
  </div>
</template>

<script>
export default {
  props: ["stat", "sub", "size", "variant"],
  computed: {
    large() {
      return this.size == 'lg';
    },
    isDark() {
      return this.variant == "dark";
    }
  },
};
</script>

<style scoped>
.dark {
  color: #444;
  border-color: #444;
}
.field {
  height: 90px;
  margin-top: 24px;
}
.field-bracket {
  height: 20px;
  position: absolute;
  bottom: 0;
  left: 12px;
  right: 12px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-width: 0px 2px 2px 2px;
  border-style: solid;
}
.stat {
  text-align: center;
  padding: 0;
  margin: 0;
}
.field h1 {
  font-weight: 300;
  font-size: 75px;
}
.field-sub {
  position: absolute;
  bottom: 10px;
  right: 30px;
  font-size: 14px;
  font-weight: normal;
}
</style>